module.exports = __webpack_public_path__ + "fonts/UniSansSemiBoldItalic.c9a55e71.woff";